import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ProvinceDTO} from '../../../../shared/dto/province.model';
import {DistrictService} from '../../../../shared/service/district.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceService} from '../../../../shared/service/province.service';
import {DistrictDTO} from '../../../../shared/dto/district.model';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {Router} from '@angular/router';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';

@Component({
  selector: 'app-district-popup',
  templateUrl: './district-popup.component.html',
  styleUrls: ['./district-popup.component.scss']
})
export class DistrictPopupComponent implements OnInit {
  @Input() districtMgtCopy_: DistrictDTO[];
  public districtMgt: any;
  public districtPopup: FormGroup;
  public provinceModel: ProvinceDTO[] = [];
  public selectedState: string;
  ActionMode = ActionMode;
  public code: string;
  public description: string;
  public province: string;
  public selectedMode;
  public href: string = "";

  constructor(public modalService: NgbModal,
              public activeModal: NgbActiveModal,
              public provinceService: ProvinceService,
              public districtService: DistrictService,
              private router : Router,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.districtPopup = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
      province: new FormControl(null),
    });
    this.href = this.router.url;
    this.districtMgt = {...this.districtMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.districtPopup.disable();
    }
    this.loadProvinces();
  }

  loadProvinces() {
    this.provinceService.getAllProvinces().subscribe(
      (data: ProvinceDTO[]) => {
        this.provinceModel = data;
      }
    );
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const districtDTO: DistrictDTO = new DistrictDTO(
            this.code,
            this.description,
            this.selectedState,
            this.province,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.districtService.saveDistrictDetails(districtDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

}
